import {
    CLEAR_BED_WING,
    CLEAR_BED_ROOM,
    GETSETUPWINGLOCATION,
    CREATESETUPWINGLOCATION,
    UPDATESETUPWINGLOCATION,
    DELETESETUPWINGLOCATION,
    GETSETUPROOMOCATION,
    CREATESETUPROOMOCATION,
    UPDATESETUPROOMOCATION,
    DELETESETUPROOMOCATION,
    GETSETUPHRSURVEYTEMPLATE,
    CREATESETUPHRSURVEYTEMPLATE,
    UPDATESETUPHRSURVEYTEMPLATE,
    DELETESETUPHRSURVEYTEMPLATE,
    GETSETUPHRTEMPLATE,
    CREATESETUPHRTEMPLATE,
    UPDATESETUPHRTEMPLATE,
    DELETESETUPHRTEMPLATE,
    GETSETUPHRCESSTAX,
    CREATESETUPHRCESSTAX,
    UPDATESETUPHRCESSTAX,
    DELETESETUPHRCESSTAX,
    GETSETUPHRSURCHARGETAX,
    CREATESETUPHRSURCHARGETAX,
    UPDATESETUPHRSURCHARGETAX,
    DELETESETUPHRSURCHARGETAX,
    GETSETUPHRATTENDANCETYPE,
    CREATESETUPHRATTENDANCETYPE,
    UPDATESETUPHRATTENDANCETYPE,
    DELETESETUPHRATTENDANCETYPE,
    GETSETUPHRPROFESSIONALTAX,
    CREATESETUPHRPROFESSIONALTAX,
    UPDATESETUPHRPROFESSIONALTAX,
    DELETESETUPHRPROFESSIONALTAX,
    GETSETUPHRINCOMETAX,
    CREATESETUPHRINCOMETAX,
    UPDATESETUPHRINCOMETAX,
    DELETESETUPHRINCOMETAX,
    CREATEDEPARTMENT,
    GETDEPARTMENT,
    UPDATEDEPARTMENT,
    DELETEDEPARTMENT,
    CREATELEAVETYPE,
    GETLEAVETYPE,
    UPDATELEAVETYPE,
    DELETELEAVETYPE,
    CREATEDESIGNATION,
    GETDESIGNATION,
    UPDATEDESIGNATION,
    DELETEDESIGNATION,
    CREATESPECIALITY,
    GETSPECIALITY,
    UPDATESPECIALITY,
    DELETESPECIALITY,
    CREATEPAYROLLTYPE,
    GETPAYROLLTYPE,
    UPDATEPAYROLLTYPE,
    DELETEPAYROLLTYPE,
    CREATEPAYROLL,
    GETPAYROLL,
    UPDATEPAYROLL,
    DELETEPAYROLL,
    GETAllSPECIALITY,
    CREATE_TWOSTEP_VERIFICATION,
    GET_TWOSTEP_VERIFICATION,
    UPDATE_TWOSTEP_VERIFICATION,
    DELETE_TWOSTEP_VERIFICATION,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATELEAVETYPE:
            return {
                ...state,
                leavetypeSaveStatus: action.payload.success,
            }
        case GETLEAVETYPE:
            return {
                ...state,
                leavetypeList: action.payload.data,
            }
        case UPDATELEAVETYPE:
            return {
                ...state,
                leavetypeUpdateStatus: action.payload.success,
            }

        case DELETELEAVETYPE:
            return {
                ...state,
                leavetypeDeleteStatus: action.payload.success,
            }
        case CREATEDEPARTMENT:
            return {
                ...state,
                departmentSaveStatus: action.payload.success,
            }
        case GETDEPARTMENT:
            return {
                ...state,
                departmentList: action.payload.data,
            }
        case UPDATEDEPARTMENT:
            return {
                ...state,
                departmentUpdateStatus: action.payload.success,
            }

        case DELETEDEPARTMENT:
            return {
                ...state,
                departmentDeleteStatus: action.payload.success,
            }
        case CREATEDESIGNATION:
            return {
                ...state,
                designatioSaveStatus: action.payload.success,
            }
        case GETDESIGNATION:
            return {
                ...state,
                designationList: action.payload.data,
            }
        case UPDATEDESIGNATION:
            return {
                ...state,
                designationUpdateStatus: action.payload.success,
            }

        case DELETEDESIGNATION:
            return {
                ...state,
                designationDeleteStatus: action.payload.success,
            }
        case CREATESPECIALITY:
            return {
                ...state,
                specialitySaveStatus: action.payload.success,
            }
        case GETSPECIALITY:
            return {
                ...state,
                specialityList: action.payload.data,
            }
        case GETAllSPECIALITY:
            return {
                ...state,
                allspecialityList: action.payload.data,
            }
        case UPDATESPECIALITY:
            return {
                ...state,
                specialityUpdateStatus: action.payload.success,
            }

        case DELETESPECIALITY:
            return {
                ...state,
                specialityDeleteStatus: action.payload.success,
            }
        case CREATEPAYROLLTYPE:
            return {
                ...state,
                payrolltypeSaveStatus: action.payload.success,
            }
        case GETPAYROLLTYPE:
            return {
                ...state,
                payrolltypeList: action.payload.data,
            }
        case UPDATEPAYROLLTYPE:
            return {
                ...state,
                payrolltypeUpdateStatus: action.payload.success,
            }

        case DELETEPAYROLLTYPE:
            return {
                ...state,
                payrolltypeDeleteStatus: action.payload.success,
            }
        case GETPAYROLL: return { ...state, payrollList: action.payload.data, }
        case CREATEPAYROLL: return { ...state, payrollSaveStatus: action.payload.success, }
        case UPDATEPAYROLL: return { ...state, payrollUpdateStatus: action.payload.success, }
        case DELETEPAYROLL: return { ...state, payrollDeleteStatus: action.payload.success, }

        case GETSETUPHRATTENDANCETYPE: return { ...state, SetupHrAttendanceList: action.payload.data, }
        case CREATESETUPHRATTENDANCETYPE: return { ...state, SetupHrAttendanceSaveStatus: action.payload.success, }
        case UPDATESETUPHRATTENDANCETYPE: return { ...state, SetupHrAttendanceUpdateStatus: action.payload.success, }
        case DELETESETUPHRATTENDANCETYPE: return { ...state, SetupHrAttendanceDeleteStatus: action.payload.success, }
        case GETSETUPHRPROFESSIONALTAX: return { ...state, setupHRProfessionalTaxList: action.payload.data, }
        case CREATESETUPHRPROFESSIONALTAX: return { ...state, setupHRProfessionalTaxSaveStatus: action.payload.success, }
        case UPDATESETUPHRPROFESSIONALTAX: return { ...state, setupHRProfessionalTaxUpdateStatus: action.payload.success, }
        case DELETESETUPHRPROFESSIONALTAX: return { ...state, setupHRProfessionalTaxDeleteStatus: action.payload.success, }
        case GETSETUPHRINCOMETAX: return { ...state, setupHRIncomeTaxList: action.payload.data, }
        case CREATESETUPHRINCOMETAX: return { ...state, setupHRIncomeTaxSaveStatus: action.payload.success, }
        case UPDATESETUPHRINCOMETAX: return { ...state, setupHRIncomeTaxUpdateStatus: action.payload.success, }
        case DELETESETUPHRINCOMETAX: return { ...state, setupHRIncomeTaxDeleteStatus: action.payload.success, }
        case GETSETUPHRSURCHARGETAX: return { ...state, setupHRSurchagrTaxList: action.payload.data, }
        case CREATESETUPHRSURCHARGETAX: return { ...state, setupHRSurchagrTaxSaveStatus: action.payload.success, }
        case UPDATESETUPHRSURCHARGETAX: return { ...state, setupHRSurchagrTaxUpdateStatus: action.payload.success, }
        case DELETESETUPHRSURCHARGETAX: return { ...state, setupHRSurchagrTaxDeleteStatus: action.payload.success, }
        case GETSETUPHRCESSTAX: return { ...state, setupHRCessList: action.payload.data, }
        case CREATESETUPHRCESSTAX: return { ...state, setupHRCessSaveStatus: action.payload.success, }
        case UPDATESETUPHRCESSTAX: return { ...state, setupHRCessUpdateStatus: action.payload.success, }
        case DELETESETUPHRCESSTAX: return { ...state, setupHRCessDeleteStatus: action.payload.success, }
        case GETSETUPHRTEMPLATE: return { ...state, setupHRTemplateList: action.payload.data, }
        case CREATESETUPHRTEMPLATE: return { ...state, setupHRTemplateSaveStatus: action.payload.success, }
        case UPDATESETUPHRTEMPLATE: return { ...state, setupHRTemplateUpdateStatus: action.payload.success, }
        case DELETESETUPHRTEMPLATE: return { ...state, setupHRTemplateDeleteStatus: action.payload.success, }
        case GETSETUPHRSURVEYTEMPLATE: return { ...state, setupHRSurveyTemplateList: action.payload.data, }
        case CREATESETUPHRSURVEYTEMPLATE: return { ...state, setupHRSurveyTemplateSaveStatus: action.payload.success, }
        case UPDATESETUPHRSURVEYTEMPLATE: return { ...state, setupHRSurveyTemplateUpdateStatus: action.payload.success, }
        case DELETESETUPHRSURVEYTEMPLATE: return { ...state, setupHRSurveyTemplateDeleteStatus: action.payload.success, }

        case GETSETUPWINGLOCATION: return { ...state, setupHRWingLocationList: action.payload.data, }
        case CREATESETUPWINGLOCATION: return { ...state, setupHRWingLocationSaveStatus: action.payload.success, }
        case UPDATESETUPWINGLOCATION: return { ...state, setupHRWingLocationUpdateStatus: action.payload.success, }
        case DELETESETUPWINGLOCATION: return { ...state, setupHRWingLocationDeleteStatus: action.payload.success, }
        case GETSETUPROOMOCATION: return { ...state, setupHRRoomLocationList: action.payload.data, }
        case CREATESETUPROOMOCATION: return { ...state, setupHRRoomLocationSaveStatus: action.payload.success, }
        case UPDATESETUPROOMOCATION: return { ...state, setupHRRoomLocationUpdateStatus: action.payload.success, }
        case DELETESETUPROOMOCATION: return { ...state, setupHRRoomLocationDeleteStatus: action.payload.success, }

        case CREATE_TWOSTEP_VERIFICATION:
            return {
                ...state,
                twoStepSaveStatus: action.payload.success,
            }

        case GET_TWOSTEP_VERIFICATION:
            return {
                ...state,
                twoStepList: action.payload.data,
            }

        case UPDATE_TWOSTEP_VERIFICATION:
            return {
                ...state,
                twoStepUpdateStatus: action.payload.success,
            }

        case DELETE_TWOSTEP_VERIFICATION:
            return {
                ...state,
                twoStepDeleteStatus: action.payload.success,
            }


        case CLEAR_BED_WING: return { ...state, setupHRWingLocationList: [] };
        case CLEAR_BED_ROOM: return { ...state, setupHRRoomLocationList: [] };



        default:
            return state
    }
}